/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum CTRoleEnum {
  CT_ADMIN = "CT_ADMIN",
  CT_APPRENTICE_TRAINER = "CT_APPRENTICE_TRAINER",
  CT_LEAD_TRAINER = "CT_LEAD_TRAINER",
  CT_SUPER_ADMIN = "CT_SUPER_ADMIN",
  CT_TRAINER = "CT_TRAINER",
  CT_USER = "CT_USER",
}

export enum RoleEnum {
  ADMIN = "ADMIN",
  CITY_LEAD = "CITY_LEAD",
  FACILITATOR = "FACILITATOR",
  HOST = "HOST",
  PARTICIPANT = "PARTICIPANT",
  TRAINER = "TRAINER",
}

export interface ForgotPasswordInput {
  email: string;
  fromCt?: boolean | null;
}

/**
 * Basic input for a group
 */
export interface GroupInput {
  id?: string | null;
  address1?: string | null;
  address2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  maxParticipants: number;
  isPrivate: boolean;
  trainerId: string;
  sessions: SessionInput[];
  registrations: RegistrationInput[];
  virtual?: boolean | null;
  isOneOnOne: boolean;
}

export interface GroupsFilterInput {
  userId?: string | null;
  trainerId?: string | null;
  location?: LocationFilterInput | null;
  virtual?: boolean | null;
  inFuture?: boolean | null;
  excludeCompleted?: boolean | null;
}

export interface LatLongInput {
  lat: number;
  long: number;
}

export interface LocationFilterInput {
  zip?: string | null;
  latLong?: LatLongInput | null;
  radius?: number | null;
  closest?: number | null;
}

export interface PaginationParamsInput {
  page?: number | null;
  perPage?: number | null;
}

export interface RegistrationInput {
  email: string;
  _destroy?: boolean | null;
}

/**
 * Input for a session
 */
export interface SessionInput {
  id?: string | null;
  name: string;
  date: string;
  time: string;
  timezone: string;
  order: number;
  status: string;
}

/**
 * Information for creating or updating a text element
 */
export interface TextElementInput {
  pageId: string;
  elementId: string;
  entityId?: number | null;
  content: string;
}

/**
 * Basic User Info
 */
export interface UserInput {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  newsletterSignedUp: boolean;
  password: string;
  passwordConfirmation: string;
  signedUpWithCtFirst?: boolean | null;
  communityIds: string[];
}

/**
 * Password Reset Information
 */
export interface UserInputPasswordReset {
  token: string;
  password: string;
  passwordConfirmation: string;
}

/**
 * Basic User Info
 */
export interface UserInputUpdate {
  id: string;
  firstName: string;
  lastName: string;
  phone: string;
  bio: string;
  ctRole?: CTRoleEnum | null;
  imgRole?: RoleEnum | null;
  email: string;
  avatar?: any | null;
  password?: string | null;
  passwordConfirmation?: string | null;
  newsletterSignedUp: boolean;
  trainerServices?: string | null;
  subTrainers?: string[] | null;
  communities?: string[] | null;
  trainerMeetingLink?: string | null;
}

export interface UsersFilterInput {
  roles?: RoleEnum[] | null;
  search?: string | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
